@if (!isSpanish) {
<div class="menu-desktop d-flex align-items-center">
  <ul class="list-unstyled mb-0 d-flex w-100 align-items-center">
    <ng-container *ngFor="let item of list; index as i">
      <li *ngIf="item.dropdown" class="position-relative" (mouseenter)="myDrop.open()" (click)="myDrop.open()"
        (mouseleave)="myDrop.close()" ngbDropdown #myDrop="ngbDropdown">
        <div class="d-inline-block desktop-dropdown w-100 d-flex justify-content-center">
          <a class="cursor-pointer d-flex align-items-center gap-2 fw-bold text-nowrap" [class.text-white]="isWhiteNav"
            [id]="item.name + i" ngbDropdownAnchor [class.active-button]="isDropdownActive(item.list)">
            <span>{{ item.name }}</span>
            <svg class="rotate" width="16" height="13" viewBox="0 0 16 13" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              @if (!isWhiteNav) {
              <path d="M8 12.5L1.0718 3.5L14.9282 3.5L8 12.5Z" fill="#1D1D1D" />
              } @else {
              <path d="M8 12.5L1.0718 3.5L14.9282 3.5L8 12.5Z" fill="#FFFFFF" />
              }
            </svg>
          </a>

          <div class="desktop-dropdown__dropdown-main-content position-absolute bg-light p-0 border-0 m-0"
            ngbDropdownMenu [attr.aria-labelledby]="item.name + i">
            <div class="desktop-dropdown__dropdown-content">
              <a ngbDropdownItem class="fw-bold" [routerLink]="dropdownItem.path" [state]="{ tab: 0 }"
                routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
                *ngFor="let dropdownItem of item.list">
                {{ dropdownItem.name }}
              </a>
            </div>
          </div>
        </div>
      </li>

      <li *ngIf="!item.dropdown" class="no-dropdown">
        <a [routerLink]="item.path" class="fw-bold no-dropdown text-nowrap" routerLinkActive="active"
          [class.text-white]="isWhiteNav">{{ item.name }}</a>
      </li>
    </ng-container>
    <li
      class="position-relative"
      (mouseenter)="hcpDrop.open()"
      (click)="hcpDrop.open()"
      (mouseleave)="hcpDrop.close()"
      ngbDropdown
      #hcpDrop="ngbDropdown"
    >
      <a
        class="header-hcp-cta text-center text-white fw-bold"
        id="hcp-menu"
        ngbDropdownAnchor
      >
        <span>For Healthcare Providers</span>
        <svg
          class="rotate"
          aria-hidden="true"
          width="16"
          height="13"
          viewBox="0 0 16 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M8 12.5L1.0718 3.5L14.9282 3.5L8 12.5Z" fill="currentColor" />
        </svg>
      </a>
      <div
        class="hcp-dropdown__menu position-absolute bg-light p-0 border-0 m-0"
        ngbDropdownMenu
        aria-labelledby="hcp-menu"
      >
        <div class="desktop-dropdown__dropdown-content">
          <a
            ngbDropdownItem
            class="fw-bold"
            [class.active]="isHcpLinkActive(hcpItem.path)"
            (click)="openHcpLink(hcpItem.path, $event)"
            *ngFor="let hcpItem of hcpLinks"
          >
            {{ hcpItem.name }}
          </a>
        </div>
      </div>
    </li>
  </ul>
</div>
} @else {
<div class="menu-desktop d-flex align-items-center">
  <ul class="list-unstyled mb-0 d-flex w-100 align-items-center">
    <ng-container *ngFor="let item of spanishLinks; index as i">
      <li *ngIf="!item.dropdown" class="no-dropdown text-start"
        [ngClass]="{'item-1': i === 0, 'item-2': i === 1, 'item-3': i === 2}">
        <a (click)="scrollToSection(item.fragment || '')" class="fw-bold" [class.text-white]="isWhiteNav"
          [innerHTML]="item.name"></a>
      </li>

    </ng-container>
    <li>
      <a class="btn btn-secondary text-center text-white fw-bold"
        (click)="spanishLink('https://questhealth.com')">Solicite la
        prueba de detección</a>
    </li>
  </ul>
</div>
}
